import React from "react";
import { useMedia } from "react-use";
import { config as cssConfig } from "@100mslive/roomkit-react";
import { NumbersIcon } from "../../icons";

const LandingInvstore = () => {
  const isMobile = useMedia(cssConfig.media.md);
  return (
    <section className="events-page-landing-section events-page-landing-section-space events-page-landing-howitwork">
      <div className="events6ix-layout-page-middle">
        <div className="events-page-landing-section-header">
          <h2
            className={`events-page-landing-section-header-heading ${
              isMobile ? "text-center" : ""
            } `}
          >
            Solve Your 3 Biggest Investor Relations Challenges
          </h2>
        </div>
        <div className="events-page-landing-howitwork-content">
          <div className="events-page-landing-howitwork-content-item">
            <div className="events-page-landing-howitwork-content-item-icon">
              <NumbersIcon type="1" />
            </div>
            <div className="events-page-landing-howitwork-content-item-title">
              Maintain Engagement During Quiet Periods
            </div>
            <div className="events-page-landing-howitwork-content-item-text">
              Your branded hub keeps investors connected when there's no news to
              report
            </div>
          </div>
          <div className="events-page-landing-howitwork-content-item">
            <div className="events-page-landing-howitwork-content-item-icon">
              <NumbersIcon type="2" />
            </div>
            <div className="events-page-landing-howitwork-content-item-title">
              Centralize Investor Communications
            </div>
            <div className="events-page-landing-howitwork-content-item-text">
              Replace fragmented tools with one platform built specifically for
              public companies
            </div>
          </div>
          <div className="events-page-landing-howitwork-content-item">
            <div className="events-page-landing-howitwork-content-item-icon">
              <NumbersIcon type="3" />
            </div>
            <div className="events-page-landing-howitwork-content-item-title">
              Measure Real IR ROI
            </div>
            <div className="events-page-landing-howitwork-content-item-text">
              Track engagement, retention, and conversion with comprehensive
              analytics
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingInvstore;
